if (window.ScrollManager) {
  console.log('[ScrollManager] Already loaded, skipping redefinition');
} else {
  class ScrollManager {
    constructor() {
      this.init();
    }

    init() {
      gsap.registerPlugin(ScrollTrigger);

      // this.initSlideTwoImages();
      // this.initHorizontalSlider();
      this.initSplitText();

      this.isMobile = window.innerWidth < 991;
    }


    initSlideTwoImages() {
      const components = document.querySelectorAll('slide-two-images');
      const start = this.isMobile ? "top-=50px" : "top=93px";
      components.forEach((component) => {
        ScrollTrigger.create({
          trigger: component,
          start,
          end: "bottom 20%",
          scrub: true,
          onUpdate: (self) => {
            const progress = self.progress;
            
            if (this.isMobile) {
              if (progress < 0.1) {
                component.setVisualState('intro');
              } else {
                component.setVisualState('step-one');
              }
            }
             else {
              if (progress < 0.01) {
                component.setVisualState('intro');
              } else if (progress >= 0.01 && progress < 0.1) {
                component.setVisualState('step-one');
              } else {
                component.setVisualState('step-two');
              }
            }
          }
        });
      });
    }

    initHorizontalSlider() {
      const sliders = document.querySelectorAll('horizontal-full-width-slider');
      sliders.forEach(slider => {
        ScrollTrigger.create({
          trigger: slider,
          start: "top 100%",
          end: "bottom 0%",
          scrub: true,
          onUpdate: (self) => {
            const progress = self.progress;
            if (progress < 0.5) {
              if (slider.visualState !== 'hero') slider.animateTo('hero');
            } else {
              if (slider.visualState !== 'slider') slider.animateTo('slider');
            }
          }
        });
      });
    }

    initSplitText() {
      const components = document.querySelectorAll('split-text-with-image');
      components.forEach((component) => {
        ScrollTrigger.create({
          trigger: component,
          start: "top 80%",
          end: "bottom 20%",
          scrub: true,
          onUpdate: (self) => {
            if (this.isMobile) {
              if (self.progress < 0.4) {
                component.collapseMedia();
              } else {
                component.expandMedia();
              }
            } else {
              if (self.progress < 0.2) {
                component.collapseMedia();
              } else {
                component.expandMedia();
              }
            }
          }
        });
      });
    }
  }

  // Initialize the manager when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
      new ScrollManager();
  });

  window.ScrollManager = ScrollManager;
}


